/**
 * Status codes observed in leave history / workflow leave approval UI.
 * Write-flow apply/cancel statuses still depend on unmounted leave routes.
 */
const LABELS: Record<string, string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Canceled',
  CANCELED: 'Canceled',
};

const MESSAGES: Record<string, string> = {
  PENDING: 'This leave request is waiting for approval.',
  APPROVED: 'This leave request was approved.',
  REJECTED: 'This leave request was rejected.',
  CANCELLED: 'This leave request was canceled.',
  CANCELED: 'This leave request was canceled.',
};

const CATEGORIES: Record<string, 'neutral' | 'success' | 'warning' | 'danger' | 'info'> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'danger',
  CANCELLED: 'neutral',
  CANCELED: 'neutral',
};

export function getLeaveStatusLabel(status: string | null | undefined): string {
  if (!status) return 'Status unavailable';
  return LABELS[status.toUpperCase()] ?? 'Status unavailable';
}

export function getLeaveStatusMessage(status: string | null | undefined): string {
  if (!status) return 'Leave status is unavailable.';
  return MESSAGES[status.toUpperCase()] ?? 'Leave status is unavailable.';
}

export function getLeaveStatusCategory(
  status: string | null | undefined,
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  if (!status) return 'neutral';
  return CATEGORIES[status.toUpperCase()] ?? 'neutral';
}
